export enum RideitChangeRequestStatus {
    Pending = 'Pending',
    Approved = 'Approved',
    Rejected = 'Rejected',
}

export interface IRideitChangeRequest {
    id: string;
    state?: RideitChangeRequestStatus;
    passengerId?: number;
    passengerName: string;
    addedUtilities?: string;
    removedUtilities?: string;
    createdAt: string;
    createdByName?: string;
    createdByPhone?: string;
    rejectedAt?: string | null;
    rejectedByName?: string;
    acceptedAt?: string | null;
    acceptedByName?: string;
}

export class RideitChangeRequest implements IRideitChangeRequest {
    id: string;
    state?: RideitChangeRequestStatus;
    passengerId?: number;
    passengerName: string;
    addedUtilities?: string;
    removedUtilities?: string;
    createdAt: string;
    createdByName?: string;
    createdByPhone?: string;
    rejectedAt?: string | null;
    rejectedByName?: string;
    acceptedAt?: string | null;
    acceptedByName?: string;
    status: RideitChangeRequestStatus;

    constructor(data?: IRideitChangeRequest | null) {
        this.id = data?.id ?? '';
        this.passengerId = data?.passengerId;
        this.passengerName = data?.passengerName ?? '';
        this.status = !data?.rejectedAt && !data?.acceptedAt ? RideitChangeRequestStatus.Pending : data?.acceptedAt ? RideitChangeRequestStatus.Approved : RideitChangeRequestStatus.Rejected;
        this.createdAt = data?.createdAt ?? '';
        this.createdByName = data?.createdByName ?? '';
        this.createdByPhone = data?.createdByPhone ?? '';
        this.addedUtilities = data?.addedUtilities ?? '';
        this.removedUtilities = data?.removedUtilities ?? '';
        this.acceptedAt = data?.acceptedAt ?? null;
        this.acceptedByName = data?.acceptedByName ?? '';
        this.rejectedAt = data?.rejectedAt ?? null;
        this.rejectedByName = data?.rejectedByName ?? '';
    }
}

export default RideitChangeRequest;
